module.exports = __webpack_public_path__ + "img/27.8b69ddf6.png";